import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';
import { BackLink } from '@common/bw-ui/ui/back-link';
import { Panel } from '@common/bw-ui/ui/panel';
import { Alert } from '@common/bw-ui/ui/alert';
import styles from './basketList.module.css';

export interface BasketListProps {
  onBack: () => void;
  className?: string;
  children: React.ReactNode;
  hasResources?: boolean;
}

export function BasketList({
  onBack,
  className,
  children,
  hasResources,
}: BasketListProps) {
  return (
    <Panel
      data-slot="basket-list"
      className={cn(
        'tw:flex tw:flex-col tw:gap-4 tw:md:gap-6 tw:p-4 tw:md:p-6 tw:pb-0',
        className,
      )}
    >
      <BackLink data-slot="back" onClick={onBack} />

      <h2
        data-slot="heading"
        className="tw:text-xl tw:font-medium tw:text-foreground mb-0"
      >
        Your basket
      </h2>

      {hasResources && (
        <Alert
          data-slot="alert"
          title="Checkout soon!"
          description="Bookings are only confirmed once payment has been made"
        />
      )}
      <div
        data-slot="items"
        className={`tw:flex tw:flex-col ${styles['basket-children-spacing']}`}
      >
        {children}
      </div>
    </Panel>
  );
}
